<template>
    <div>
        <el-form ref="formRef" :rules='formRules' :model="form" label-width="90px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select disabled v-model="form.projectId" placeholder="请选择" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="设备名称" prop="deviceId" >            
                                <div style="display:flex">
                                        <el-input v-model="form.deviceName" disabled></el-input>
                                        <el-button  v-if="model!='view'" type="primary" size="small" @click="choiceDevice" >选择</el-button> 
                                </div>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="设备类型" prop="deviceType">
                             <el-input v-model="form.deviceTypeName" disabled></el-input>
                          </el-form-item>
                      </el-col>
                    
                      <el-col :span="8">
                          <el-form-item label="设备编号" prop="deviceCode" >
                              <el-input disabled v-model="form.deviceCode"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="设备型号" prop="deviceModel" >
                              <el-input disabled v-model="form.deviceModel"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="生产产家" prop="deviceProductionFactory" >
                              <el-input disabled v-model="form.deviceProductionFactory"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="所属部门" prop="deptName" >
                              <el-input disabled v-model="form.deptName"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="存放位置" prop="areaName" >
                              <el-input disabled v-model="form.areaName"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="设备用途" prop="useType" >
                              <el-select   :disabled="model=='view'" v-model="form.useType" placeholder="请选择" style="width:100%">
                                  <el-option
                                      v-for="item in deviceUseTypeList"
                                      :key="item.dictKey"
                                      :label="item.dictValue"
                                      :value="item.dictKey">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8" style="height:54px" >
                          <el-form-item  label="检测日期" prop="testTime" style="width:100%" >
                            
                             <el-date-picker
                             :disabled="model=='view'"
                             style="width:100%" 
                            v-model="form.testTime"
                            type="date"
                            placeholder="选择日期时间"
                            align="right"
                            value-format="yyyy-MM-dd 00:00:00"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8" style="height:54px" >
                          <el-form-item  label="有效期" prop="expiryTime" style="width:100%" >
                            
                             <el-date-picker
                             :disabled="model=='view'"
                             style="width:100%" 
                            v-model="form.expiryTime"
                            type="date"
                            placeholder="选择日期时间"
                            align="right"
                            value-format="yyyy-MM-dd 00:00:00"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="检测费用" prop="testCost">
                            <moneyInput  :disabled="model=='view'" v-model="form.testCost" placeholder="请输入检测费用" template="append" style="width: 100%"  />
                          </el-form-item>
                    </el-col>
                    <el-col :span="8">
                          <el-form-item label="检测机构" prop="testInstitution" >
                              <el-input  :disabled="model=='view'"  v-model="form.testInstitution"  maxlength="50"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="合同名称" prop="contractId" >
                              <div style="display:flex">
                                        <el-input placeholder="请选择 合同名称" disabled v-model="form.contractName"></el-input>
                                        <el-button  v-if="model!='view'" type="primary" size="small" @click="choiceConstractBtn" >选择</el-button> 
                                </div>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="合同编号" prop="contractCode"  >
                              <el-input placeholder="请输入 合同名称" disabled v-model="form.contractCode"></el-input>
                          </el-form-item>
                      </el-col>
                      
                      <el-col :span="24">
                          <el-form-item label="检测结论" prop="testConclusion" >
                            <el-input type="textarea"    :disabled="model=='view'" placeholder="请输入 检测结论" v-model="form.testConclusion" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="备注" prop="description" >
                            <el-input    :disabled="model=='view'" type="textarea"  placeholder="请输入 备注" v-model="form.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="检测附件"  >
                            <el-button v-if="model!='view'" type="primary" icon="el-icon-plus" size="small" @click="addAttachRecord">
                              新 增</el-button
                            >
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-table
                          :data="this.form.attachList"
                          style="width: 100%">
                          <el-table-column
                            prop="attachName"
                            label="附件名称"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="address"
                            label="所在位置"
                            >
                            <template slot-scope="scope">
                              <div>
                                <el-select
                                v-model="scope.row.areaType"
                                style="width:100%"
                                disabled
                              >
                                <el-option
                                  v-for="item in attachAreaList"
                                  :key="item.dictKey"
                                  :label="item.dictValue"
                                  :value="item.dictKey"
                                >
                                </el-option>
                              </el-select>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="description"
                            label="备注"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="attachId"
                            label="附件">
                            <template slot-scope="scope">
                              <div>
                                <el-button
                                type="text"
                                size="small"
                            
                                @click="viewAttach(scope.row)"
                                >预览
                              </el-button>
                              <el-button
                                type="text"
                                size="small"
                            
                                @click="downloadAttach(scope.row)"
                                >下载
                              </el-button>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                          v-if="model!='view'"
                            label="操作">
                            <template slot-scope="scope">
                              <div>
                                <el-button
                                type="text"
                                size="small"
                            
                                @click="editAttach(scope)"
                                >编辑
                              </el-button>
                              <el-button
                                type="text"
                                size="small"
                            
                                @click="deleteAttach(scope)"
                                >删除
                              </el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-col>
                     
                    
                      
                </el-row>
          </el-form>
            
          <div style="    text-align: right;" v-if="model != 'view'">
              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
                {{ model == 'add' ? '提交' : '修改' }}
              </el-button>
              <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
                取消
              </el-button>
            </div>
            <!-- 选择设备对话框 -->
            <el-dialog
            title="选择设备"
            v-if="choiceDeviceDialogFlag"
            :visible.sync="choiceDeviceDialogFlag"
            append-to-body="true"
            width="80%"
            >
            <choiceDevice @cancelOperate="choiceDeviceCancleOperate" :projectId="this.form.projectId" @choiceData="getDevice"></choiceDevice>
            </el-dialog>
            <hr-dialog
            title="选择合同"
            :allowFull="false"
            width="55%"
            :visible.sync="choiceContractDialogFlag"
          >
            <template slot="body">
              <choiceContract @cancleOperate="contractCancleOperate" :projectId='this.form.projectId' @close='dialogClose'  @getConstract="getContract"></choiceContract>
            </template>
          </hr-dialog>
          <hr-dialog
            :title="attachTitle"
            :allowFull="false"
            width="55%"
            :visible.sync="attachFormFlag"
          >
            <template slot="body">
              <AttachForm :model="attachFormModel"  :deviceTestInfo="row" :attach="attachInfo" @attachSubmit="getAttach" @attachEdit="editAttachBack"  v-if="attachFormFlag"></AttachForm>
            </template>
          </hr-dialog>
         
    </div>
</template>

<script>



import choiceDevice from '@/components/device/deviceChoice/index';
import VUpload from '@/views/components/v-upload';

import ATime from '@/components/aTime/index';
import AttachForm from "./attachForm.vue"
import choiceContract from '@/components/choiceContract/choiceContract-v2.vue';
import { getDictionary ,getBisDictData} from '@/api/common.js';
import {deviceTestSave,getDeviceTestDetail,updateDeviceTestDetail} from "./index.js";
import urlSettings from '@/config/url-settings';
import { downloadFile } from '@/api/crmedical/contract/add';
import { getProjectList } from '@/api/crmedical/project/project';
export default {
  components: { VUpload, choiceContract, choiceDevice, ATime ,AttachForm},
  props: {
    cancelBtn:{
        type:Boolean,
        default:true,

    },
   
    model:{},
    projectList: [],
    row:{}
  },
  data() {
    return {
      attachInfo:{},
      attachFormModel:"add",
      attachTitle:'新增附件',
      attachFormFlag:false,
      attachList:[],
      choiceContractVisible:false,
      deviceUseTypeList:[],
      realInspectManList:[],
      inspectionResultList: [
        {
          errorFlag: 1,
          name: '异常',
        },
        {
          errorFlag: 0,
          name: '正常',
        },
      ],
      standardList: [],
      currentDataOption: [],
      handleIdList: [], //处理人
      OperateList: [],
      isUpdate: false,
      //判断是否为编辑
      operatConsumableIndex: undefined,
      choiceConsumableFlag: false, //选择耗材对话框
      choiceContractDialogFlag: false, 
      choiceDeviceDialogFlag: false, //选择设备对话框
 
      dialogVisible: false,
      dialogConstract: {},
      formRules: {
        deviceId: [{ required: true, message: '请选择设备', trigger: 'change' }],
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        expiryTime: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        useType: [{ required: true, message: '请选择设备用途', trigger: 'change' }],
        testTime: [{ required: true, message: '请选择检测日期', trigger: 'change' }],
        testInstitution: [{ required: true, message: '请选择检测机构', trigger: 'change' }],
        testConclusion: [{ required: true, message: '请输入检测结论', trigger: 'change' }],
      },
      form:{
        projectId:'',
        contractName:'',
        contractCode:'',
        deviceId:'',
        deviceCode:'',
        testTime:'',
        expiryTime:'',
        testCost:'',
        testInstitution:'',
        contractId:'',
        testConclusion:'',
        description:'',
        deviceTypeName:'',
        attachList:[],
        deviceModel:'',
        deviceProductionFactory:'',
        deptName:'',
        areaName:'',

       
      },
      previewShow: false, // 图片预览弹框是否显示着
      previewImgs: [], // 需要预览的图片列表
      attachAreaList:[],
    };
  },
  created() {
  
    this.initData();
  },
  watch:{

    
  },
  methods: {
    editAttachBack(){
      this.attachFormFlag = false
    },
    cancleRecord(){
      this.$emit("cancle")
    },
    deleteAttach(scope){
          this.form.attachList.splice(scope.$index,1)
    },
    editAttach(scope){
      this.attachTitle ="编辑附件"
      this.attachFormModel ='edit';
      this.attachInfo =scope.row
      this.attachFormFlag = true
      
    },
   viewAttach(row){
    let attach = row
    
    let url = urlSettings.FILE_VIEW_URL + encodeURIComponent(Base64.encode(attach.attachUrl))
            window.open(url); 
   },
   downloadAttach(row){
    downloadFile(row.attachUrl, row.attachName);
   },
    getAttach(data){
      console.log("fujian",data)
      this.form.attachList.push(data)
      this.attachFormFlag= false
    },
    addAttachRecord(){
      this.attachTitle ="新增附件"
      this.attachFormModel ='add';
      this.attachFormFlag =true
    },
    getContract(val) {
      console.log(val);
      this.form.contractId = val.id;
      this.form.contractName = val.name;
      
      this.form.contractCode = val.code
      this.choiceContractDialogFlag = false;
    },
    choiceConstractBtn(){
      this.choiceContractDialogFlag = true
    },
    choiceDeviceCancleOperate() {
      this.choiceDeviceDialogFlag = false;
    },
   
  
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;})
      if(this.model!='add'){
        
        getDeviceTestDetail({
          id:this.row.id
        }).then(res=>{
          this.form= res.data
          this.form.deviceName= this.row.deviceName
          this.form. deviceCode=this.row.deviceCode
        this.form.deviceTypeName= this.row.deviceType
        this.form.deviceModel= this.row.deviceModel
        this.form.deviceProductionFactory= this.row.deviceProductionFactory
        this.form.contractName= this.row.contractName
        this.form.contractCode= this.row.contractCode
        this.form.deptName= this.row.deptName
        this.form.areaName= this.row.areaName
        this.form.useType+=''
        this.getProDic(this.form.projectId)
        })
      }else{
        this.form.projectId = this.row.projectId
        this.getProDic(this.form.projectId)
      }
      
      
      
    },
    getProDic(projectId){
      getBisDictData({
        code: 'project_device_use_type',
        projectId:projectId,
      }).then((res) => {
        this.deviceUseTypeList = res.data;
      });
      getBisDictData({
        projectId:projectId,
        code: 'project_device_attach_area',
      }).then(res=>{
        this.attachAreaList = res.data
      })
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            if(this.model!="add"){
        updateDeviceTestDetail(this.form).then(res=>{
          this.$message.success("修改成功")
          this.$emit("success")
        })
      }else{
        deviceTestSave(this.form).then(res=>{
          this.$message.success("新增成功")
          this.$emit("success")
        })
      }
          } 
        });
      
     
    },
    getDevice(val) {
      console.log(val);
      console.log('查询标准');
      //根据设备id查找标准
    
      this.form.deviceProductionFactory = val.productionFactory
      this.$set(this.form, 'deviceId', val.id);
      this.$set(this.form, 'deviceName', val.name);
      this.form.deviceModel = val.model
      this.form.areaName = val.areaName;
      this.form.deviceTypeName = val.typeName;
      this.form.deviceCode = val.code;
      this.form.deptName = val.deptName;
 
      this.choiceDeviceDialogFlag = false;
    },

    choiceDevice() {
      this.choiceDeviceDialogFlag = true;
    },

    closeRecord() {
      this.$emit('cancelOperate');
    },
    contractCancleOperate(){
      this.choiceContractDialogFlag = false
    },
    choiceDeviceCancleOperate(){
      this.choiceDeviceDialogFlag = false
    },
    dialogClose() {
      this.dialogVisible = false;
      this.choiceContractDialogFlag = false
    },
    getGroupListByModuleType(projectId) {
      getGroupListByModuleType({ projectId: projectId }).then((res) => {
        res.data.forEach((item) => {
          item.label = item.realNameAndPhone;
          item.value = item.userId;
        });
        this.handleIdList = res.data;
      });
    },
    
  },
};
</script>

<style scoped>
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
  margin-top: 10px;
}
.btn::after {
  display: none;
}
.btnArea {
  margin-top: 10px;
  text-align: center;
}
.el-col-8{
  height: 54px;
}
</style>
